(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ai_gen_block_1b1a344"] && !Shopify.designMode) return;
  try {
    document.addEventListener("DOMContentLoaded", function () {
  // var ai_id = {{ ai_gen_id }};
  
  // console.log("ai ", ai_id);
  const form = document.querySelector('.ai-newsletter-signup__form-{{ ai_gen_id }}');
  if (!form) return;

  form.addEventListener('submit', async function (event) {
    event.preventDefault();
console.log('welcome');
return;
    const emailInput = form.querySelector('input[type="email"]');
    const email = emailInput.value.trim();

    
    try {
      const response = await fetch("https://api.beehiiv.com/v2/publications/pub_c632edb6-9807-4970-bac8-7945a6eae526/subscriptions", {
        method: "POST",
        headers: {
          "Authorization": "Bearer iG4YhgeC5cBlgBJIkpYmVp2AUq3Ml7t9AXDB1urhhZMO7fckb561nod5ISCe1FM",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          email: email,
          reactivate_existing: true,
          utm_source: "shopify",
          utm_medium: "organic",
          utm_campaign: "newsletter"
        }),
      });

      if (response.ok) {
        alert("🎉 Thank you! Your email has been successfully subscribed to our newsletter.");
        emailInput.value = "";
      } else {
        const error = await response.json();
        console.error("Beehiiv error:", error);
        alert("⚠️ Subscription failed. Please try again later.");
      }
    } catch (err) {
      console.error("Network error:", err);
      alert("❌ Something went wrong. Please try again later.");
    }
  });
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["ai_gen_block_c07d215"] && !Shopify.designMode) return;
  try {
    document.addEventListener("DOMContentLoaded", function () {
  const newsLetterBtn = document.querySelector('#newsletterForm-btn');

  const form = document.querySelector('.ai-newsletter-signup__form');
  const aiId = form.dataset.aiId;
  console.log(form);
  if (!form) return;
console.log("yeah");
  form.addEventListener('submit', async function (event) {
    event.preventDefault();
console.log("yeah --- ");
    const emailInput = form.querySelector('input[type="email"]');
    const email = emailInput.value.trim();

    if (!email) {
      alert("⚠️ Please enter your email address.");
      return;
    }
    console.log("hellow");
    try {
      const response = await fetch("https://api.beehiiv.com/v2/publications/pub_c632edb6-9807-4970-bac8-7945a6eae526/subscriptions", {
        method: "POST",
        headers: {
          "Authorization": "Bearer iG4YhgeC5cBlgBJIkpYmVp2AUq3Ml7t9AXDB1urhhZMO7fckb561nod5ISCe1FM",
          "Content-Type": "application/json",
          "mode": 'cors',
        },
        body: JSON.stringify({
          email: email,
          reactivate_existing: true,
          utm_source: "shopify",
          utm_medium: "paid",
          utm_campaign: "meta",
        }),
      });
      console.log('response ', response);
      if (response.ok) {
        alert("🎉 Thank you! Your email has been successfully subscribed to our newsletter.");
        emailInput.value = "";
      } else {
        const error = await response.json();
        console.error("Beehiiv error:", error);
        alert("⚠️ Subscription failed. Please try again later.");
      }
    } catch (err) {
      console.error("Network error:", err);
      alert("❌ Something went wrong. Please try again later.");
    }
  });
});
  } catch(e) { console.error(e); }
})();

})();
